export const GRAYS_WEBSITE_PREFIX = 'https://www.grays.com/';


export const QUERY_KEYS = {
    "AUTH": "auth",
    "CMS_DATA": "cmsData",
    "GET_ACCOUNT_SALE_INVOICE": "getAccountSaleInvoice",
    "LISTINGS": "listings",
    "MAPPED_SELLERS_DATA": "mappedSellersData",
    "NOTIFICATIONS": "notifications",
    "SELL_AUTH": "sellAuth",
    "STATISTICS": "statistics",
    "VIEW_PAYMENT_DETAILS": "viewPaymentDetails",
    "WHATS_NEXT": "whatsNext",
}